<template>
  <div>

    <!-- Data Stores Hack, need to be loaded first -->
    <ShiftStoreOld ref="shiftStoreOld"/>
    <!-- ///////////////////////////////////////// -->

    <h1>Shifts</h1>
    <h3>⚠️🚧Work In Progess🚧⚠️</h3>
    Show Data Entry: <input type="checkbox" v-model="ls.showDataEntry" /> 
    Show Transaction Counts: <input type="checkbox" v-model="ls.showTransCounts" />
    Number Of Shifts: <input v-model="ls.numOfShifts" />
    <div v-for="location in $locations" :key="location">
      <ShiftOld 
        :location="location" 
        :showDataEntry="ls.showDataEntry" 
        :showTransCounts="ls.showTransCounts" 
        :numOfShifts="ls.numOfShifts" 
      />
    </div>
  </div>
</template>

<script>
import ShiftOld from '@/pages/Reports/Shifts/Components/ShiftOld.vue'
import ShiftStoreOld from '@/pages/Reports/Shifts/Stores/ShiftStoreOld.vue'
import localstorageMixin from '@/mixins/localstorageMixin.js'

export default {
  mixins: [localstorageMixin],
  components : {ShiftOld, ShiftStoreOld},
  name: 'ShiftsPageOld',
  provide() {
    return {
      shiftsPage: this
    }
  },
  data () { return { 
    ls: {
      showDataEntry: false,
      showTransCounts: false,
      numOfShifts: 10,
    },
    } 
  },

}
</script>